import {
  SYNC_USER,
  LOGOUT
} from '../actions/types';

//user state can be false (if not logged in), authenticating (if currently fetching user), or the user{} object

export default function(state = 'authenticating', action){
  switch(action.type){
    case SYNC_USER:
      return action.payload;
    case LOGOUT:
      console.error("Action Not Implemented: " + LOGOUT);
      return action.payload;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js